/* eslint-disable react/prefer-stateless-function */

import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { Button } from '@99designs/common/components/Button';
import { Icon } from '@99designs/common/components/Icon';
import Accordion from 'apps/find-designers/components/Accordion';
import KeywordFilter from './KeywordFilter';
import CommonFilters from './CommonFilters';

class MobileFilters extends Component {
    render() {
        const { filterStore } = this.props;
        const keywordFilter = filterStore.getFilterByName('q');

        return (
            <div className="mobile-filter-panel">
                <div className="mobile-filter-panel__item">
                    <KeywordFilter filter={keywordFilter} onChange={this.props.onChange} />
                </div>
                <Accordion>
                    {({ isOpen, onToggle }) => (
                        <div>
                            <div className="mobile-filter-panel__item">
                                <Button
                                    data-toggle-button
                                    variations={['secondary']}
                                    icon={<Icon variations={[isOpen ? 'up-2' : 'down-2']} />}
                                    iconAlignment="right"
                                    type="button"
                                    onClick={onToggle}
                                >
                                    <FormattedMessage id="filters_heading" />
                                </Button>
                            </div>
                            {isOpen && (
                                <div className="mobile-filter-panel__item">
                                    <CommonFilters
                                        onChange={(name, value) => {
                                            onToggle();
                                            this.props.onChange(name, value);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </Accordion>
            </div>
        );
    }
}

MobileFilters.propTypes = {
    filterStore: PropTypes.shape({
        getFilterByName: PropTypes.func.isRequired,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
};

export { MobileFilters as MobileFiltersComponent };
export default inject('filterStore')(observer(MobileFilters));



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/MobileFilters.jsx